module.exports = __webpack_public_path__ + "img/pdf.6eec3136.png";